var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { getStatusColor } from '../utils';
import { colors } from '../../../abstracts';
export var DropdownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n\n  &:hover + .dropdown_helper_text {\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  width: 100%;\n\n  &:hover + .dropdown_helper_text {\n    color: ", ";\n  }\n"])), function (_a) {
    var fieldStatus = _a.fieldStatus;
    return getStatusColor('color')[fieldStatus] || colors.black;
});
var templateObject_1;
